import { IconProps, NocIconGenerator } from '../common';

export const ArrowEnd = (props: IconProps): JSX.Element => (
    <NocIconGenerator
        {...props}
        createIconProps={{
            displayName: 'ArrowEnd',
            path: (
                <>
                    <path
                        stroke="#292D32"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        strokeWidth={2}
                        d="M16 19.92 9.48 13.4c-.77-.77-.77-2.03 0-2.8L16 4.08"
                    />
                    <path
                        d="M6.85712 5.14285V18.8571"
                        stroke="#292D32"
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                </>
            ),
        }}
    />
);
